// Shared parse cache keyed by document text. Both the linter (debounced
// 300 ms) and the status-bar updater (every keystroke) route through this
// so we parse at most once per unique document state.

import type { Kolilang, ParseResult } from './wasm';

let kolilangRef: Kolilang | null = null;
let cache: { text: string; parse: ParseResult } | null = null;

export function bindKolilang(kolilang: Kolilang): void {
  kolilangRef = kolilang;
}

export function ensureParse(text: string): ParseResult {
  if (!kolilangRef) throw new Error('parse-cache: bindKolilang() not called');
  if (cache && cache.text === text) return cache.parse;
  const parse = kolilangRef.parse(text);
  cache = { text, parse };
  return parse;
}
